import Navbar from 'components/navbar';
import { ReleasingPriority } from 'data/pps/mockData';
import { PrinterIcon } from 'lucide-react';
import { observer } from 'mobx-react';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Skeleton } from 'primereact/skeleton';
import classes from './releasingPriorityList.module.scss';
import { useReleasingPriorityList } from './useReleasingPriorityList';

const ReleasingPriorityList = () => {
  const { isLoading, releasingPriorityData, contentRef, getDateWithTime, handlePrint } =
    useReleasingPriorityList();

  // Template for notes column to handle null values and truncate long text
  const notesTemplate = (rowData: ReleasingPriority) => {
    if (!rowData.notes) {
      return '-';
    }

    const maxLength = 20; // Adjust this value as needed
    const truncated =
      rowData.notes.length > maxLength
        ? `${rowData.notes.substring(0, maxLength)}...`
        : rowData.notes;

    return (
      <div className="notesContainer">
        <span>{truncated}</span>
        {rowData.notes.length > maxLength && (
          <div id="notes-tooltip" className="notes-tooltip">
            {rowData.notes}
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <Navbar heading="Releasing Priority List" />
      <div className={classes.releasingPriorityContainer}>
        {isLoading ? (
          <Skeleton height="100rem" />
        ) : (
          <div id="content" className={classes.tableWrapper} ref={contentRef}>
            <div id="headerContainer" className={classes.headerContainer}>
              <div className={classes.dateContainer}>
                <p>
                  <span>Date: </span>
                  {getDateWithTime()}
                </p>
              </div>
              <div>
                <Button
                  id="print-btn"
                  icon={<PrinterIcon color="#4D2E6D" />}
                  rounded
                  style={{ backgroundColor: '#D6B1FD', border: 'none' }}
                  onClick={handlePrint}
                />
              </div>
            </div>
            <DataTable value={releasingPriorityData} responsiveLayout="scroll" stripedRows>
              <Column field="jobs" header="Jobs" />
              <Column field="ndc" header="NDC" />
              <Column field="releaseBy" header="Release By" />
              <Column field="jobStartTime" header="Job Start Time" />
              <Column field="room" header="Room" />
              <Column field="status" header="Status" />
              <Column field="notes" header="Notes" body={notesTemplate} />
            </DataTable>
          </div>
        )}
      </div>
    </>
  );
};

export default observer(ReleasingPriorityList);
